import React, { FC, useEffect, useState, useCallback, useRef, useMemo } from 'react'
import { IconButton, makeStyles, useTheme, Theme } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { useHistory } from 'react-router-dom'

import { RouteTransition } from 'components'
import { EventStages } from '../../types'
import { ISession, livestreamSource } from '../../helpers'
import { ReactComponent as LiveIcon } from 'assets/live-icon.svg'

// import { useMeetingEndedRedirect } from 'hooks'
import { useAppState, useVideoChatContext, VideoChatProvider } from 'providers'
import { graphQLMutation } from '../../graphql/helpers'
import { createUserInteraction } from '../../graphql/mutations'

interface ILiveStreamProps {
  eventStage?: EventStages
  setPostLiveStream: (changeVal: boolean) => void
}
export const LiveStreamWrapper: FC<ILiveStreamProps> = (props: ILiveStreamProps) => (
  <VideoChatProvider>
    <VidibleLiveStream {...props} />
  </VideoChatProvider>
)

const VidibleLiveStream: FC<ILiveStreamProps> = ({ eventStage, setPostLiveStream }) => {
  const {
    appState: { user }
  } = useAppState()
  const classes = useStyles()
  const [redirectTrigger, setRedirectTrigger] = useState<boolean>(false)
  const [openModal, setOpenModal] = useState(false)
  const history = useHistory()

  const [qaDialogOpen, setQADialogOpen] = useState<boolean>(false)
  const [tabValue, setTabValue] = useState<number>(0)
  const [isAdmin, setAdmin] = useState<boolean>(false)
  const theme = useTheme()

  const { videoChatState, dispatch } = useVideoChatContext()
  const [currentSession, setCurrentSession] = useState<ISession | null>(null)
  const [participantId, setParticipantId] = useState<string>('')
  const setLoading = useCallback((payload: boolean) => dispatch({ type: 'SET_LOADING', payload }), [])

  const handleChange = (_, newValue) => {
    setTabValue(newValue)
  }

  // useEffect(() => {
  //   if (eventStage && ![EventStages.COUNTDOWN, EventStages.LIVESTREAM].includes(eventStage)) {
  //     setRedirectTrigger(true)
  //   }
  // }, [eventStage])

  useEffect(() => {
    if (user?.id) {
      generateInteraction('joined')
    }
  }, [user])

  useEffect(() => {
    return () => {
      generateInteraction('joined')
    }
  }, [])

  useEffect(() => {
    if (videoChatState?.session?.admins?.items?.some?.(a => a.userId === user?.id)) {
      setAdmin(true)
    }
  }, [videoChatState?.session?.admins])

  function generateInteraction(trigger) {
    if (user?.id) {
      graphQLMutation(createUserInteraction, {
        name: 'livestream',
        trigger: trigger,
        type: 'livestream',
        userId: user?.id
      })
    }
  }

  const close = () => {
    generateInteraction('left')

    if (eventStage && [EventStages.LIVESTREAMENDING, EventStages.POSTLIVESTREAM].includes(eventStage)) {
      setPostLiveStream(true)
    }
    setRedirectTrigger(true)
  }

  return (
    <>
      <div className={classes.root}>
        <IconButton
          className={classes.closeButton}
          onClick={() => close()}
          disableFocusRipple
          disableRipple
          disableTouchRipple
        >
          Exit
        </IconButton>
        {eventStage === EventStages.LIVESTREAM && <LiveIcon className={classes.liveIcon} width={60} height={30} />}
        <>
          <iframe
            className={classes.iframe}
            title='Verizon 5G Ready'
            srcDoc={livestreamSource}
            allow='autoplay; fullscreen'
            allowFullScreen
          ></iframe>
        </>

        <RouteTransition animationTrigger={redirectTrigger} route='/event' timeout={300} />
      </div>
    </>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: '100%'
  },
  iframe: {
    position: 'absolute',
    zIndex: 1000,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 'none'
  },
  closeButton: {
    position: 'absolute',
    top: 50,
    right: 10,
    zIndex: 2000,
    color: '#000',
    padding: '18px 12px',
    backgroundColor: 'rgba(255,255,255,0.5)',
    '&:hover': {
      color: '#fff'
    },
    '& svg': {
      color: '#000'
    }
  },
  liveIcon: {
    position: 'absolute',
    top: 50,
    left: 10,
    width: 60,
    zIndex: 2000
  },
  modal: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    zIndex: 9999,
    height: '100vh',
    width: '100vw',
    top: 0,
    left: 0
  },
  modalBody: {
    backgroundColor: '#fff',
    width: 560,
    position: 'relative'
  },
  closeButtonModal: {
    position: 'absolute',
    right: 0,
    top: 0
  },
  toastESSButton: {
    height: '24px',
    fontSize: '12px',
    marginBottom: '1rem',
    padding: '0 20px',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white'
    }
  },
  streamSide: {
    width: '100%'
  },
  chatSide: {},
  hamburgerMenu: {
    position: 'absolute',
    top: '30px',
    right: '45px',
    display: 'inline-block',
    cursor: 'pointer'
  },
  messagePaper: {
    '&.MuiPaper-root': {
      backgroundColor: 'white !important'
    }
  },
  logo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60px',
    maxHeight: '60px'
  },
  mainMenu: {
    height: 'calc(100% - 60px)',
    overflow: 'scroll'
  },
  displayMenu: {
    width: '350px',
    color: 'white',
    height: 'calc(100% - 60px)',
    display: 'flex',
    flexDirection: 'column'
  },
  toolbar: {
    paddingRight: 0,
    paddingLeft: 0,
    alignItems: 'flex-start',
    minHeight: '50px',
    borderBottom: '1px solid #D8DADA'
  },
  peoplePanel: {
    '& .MuiBox-root': {
      paddingTop: 0
    }
  },
  black: {
    background: 'black'
  },
  dialog: {
    position: 'absolute',
    top: 0,
    width: '100%'
  },
  avatarContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    color: 'white',
    alignItems: 'center',
    position: 'relative'
  },
  avatarCircle: {
    width: '100px',
    height: '100px',
    background: 'blue',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9
  },
  avatarLetter: {
    fontSize: '3rem'
  }
}))
